function IconWithTitle({ icon, text = "", className }) {
  return (
    <div
      className={`flex flex-row gap-x-2 items-center ${
        className ? className : undefined
      }`}
    >
      <>{icon}</>
      <div className="text-lg text-grey-500 font-medium capitalize">
        {text}
      </div>
    </div>
  );
}

export default IconWithTitle;
